<div class="radio-group-container">
    <ng-content></ng-content>
  </div>